import { lazy, useEffect, useMemo, useState } from 'react';
import cx from 'classnames';
import { Navbar, Nav, Image, Overlay, Tooltip } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { UserCard, UniversalSearchForm } from '../common';
import Logo from '../assets/images/lf-logo.svg';
import { MAIN_MENU } from '../constants/menu';
import { ADMIN_DASHBOARD, ADMIN_MY_PRODUCTS_3DMODAL_EACH } from '../constants/routePathConstants';
import { icons } from '../assets/';
import { dispatcher } from '../helpers/projectHelper';
import { activitySelector, setNotificationCount } from '../redux/slicers/activitySlicer';
import { apiReadNewNotifications } from '../helpers/api';
import { useSelector } from 'react-redux';
import { useStaticPermissions } from '../hooks/usePermissions';
import { PERMISSION } from '../constants/permissionConstants';
import { useUserContext } from '../contexts/UserContext';
import Close from '../assets/images/close.png';
import { showHideTooltip } from '../components/gamificationTooltip/helpers';
import { Mixpanel, MxEvent, MIX_VisitedPage } from '../common/Mixpanel';
import { selectHasAutomationsData } from '../redux/slicers/subscriptionSlicer';
import { OrganizationSwitcher } from '../common/OrganizationSwitcher';
import MenuDropdown from '../common/MenuDropdown';
import PlusIcon from '../components/icons/PlusIcon';
import ImagineLogo from '../assets/images/imagine-logo-black-text.png';
import {
  Lifestyle_Label,
  Lifestyle_Value,
  Silo_Label,
  Silo_Value,
  URL_SLUG__ROOM_TYPE_MAP,
  Vignette_Label,
  Vignette_Value,
} from '../constants/filters';
import { CloseIcon, LogoutIcon, SearchBarIcon } from '../assets/icons';
import Button from '../components/Button';
import { hideSearchBar } from '../App';
const { LifestyleIconTemplate, SiloIconTemplate, VignetteIconTemplate } = icons;
const { NotificationsIcon, NotificationsActiveIcon, NotificationsBellIcon } = icons;

const NotificationsPanel = lazy(() => import('../common/notifications/NotificationsPanel'));

const ActionMenu = [
  {
    label: Silo_Label,
    value: Silo_Value,
    icon: <SiloIconTemplate />,
  },
  {
    label: Vignette_Label,
    value: Vignette_Value,
    icon: <VignetteIconTemplate />,
  },
  {
    label: Lifestyle_Label,
    value: Lifestyle_Value,
    icon: <LifestyleIconTemplate />,
  },
];

export default function CommonMenu({ setShowMenu, showMenu }) {
  const { logout } = useUserContext();
  const navigate = useNavigate();
  const location = useLocation();
  const URLParams = useParams();
  const [notification, setNotification] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [cardFlag, setUserCardVisiblity] = useState(false);
  const userCtx = useUserContext();
  const { currentUser, isGuestUser, isGuestLogin } = userCtx;
  const { notificationCount } = useSelector(activitySelector);
  const showTooltip = currentUser?.user?.other_info?.showTemplateTooltip || false;
  const [tooltip, setTooltip] = useState(false);
  const [timer, setTimer] = useState(null);
  const [searchToggle, setSearchToggle] = useState(false);
  const [showNewFileBtn, setShowNewFileBtn] = useState(true);
  const [refreshOrgList, setRefreshOrgList] = useState(false);

  useEffect(() => {
    toggleNewFilesButton();
  }, [location?.pathname]);

  useEffect(() => {
    const body = document.getElementsByTagName('body');
    if (showMenu) {
      body?.[0]?.classList?.add('overflow-hidden');
    } else {
      body?.[0]?.classList?.remove('overflow-hidden');
    }
  }, [showMenu]);

  const toggleNewFilesButton = () => {
    const keyLists = Object?.keys(URLParams);
    const keyName = keyLists?.[0];
    const pathReplaceValue = `:${keyName}`;
    const valueParam = URLParams[keyName];
    if (
      location.pathname === ADMIN_MY_PRODUCTS_3DMODAL_EACH?.replace(pathReplaceValue, valueParam)
    ) {
      showNewFileBtn && setShowNewFileBtn(false);
    } else {
      !showNewFileBtn && setShowNewFileBtn(true);
    }
  };

  useEffect(() => {
    const body = document.getElementsByTagName('body');
    if (showMenu) {
      body?.[0]?.classList?.add('overflow-hidden');
    } else {
      body?.[0]?.classList?.remove('overflow-hidden');
    }
  }, [showMenu]);

  const handleHidePopover = () => {
    setNotification(false);
  };

  const handleHideMenu = () => {
    if (isMenuVisible) {
      document.getElementById('hamburgerMenu').click();
    }
  };

  useEffect(() => {
    if (isMenuVisible) {
      window.addEventListener('click', handleHideMenu);
    }

    return () => {
      window.removeEventListener('click', handleHidePopover);
      window.removeEventListener('click', handleHideMenu);
    };
  }, [notification, isMenuVisible]);

  useEffect(() => {
    if (showTooltip) {
      if (timer) {
        clearTimeout(timer);
      }
      const timeout = setTimeout(() => {
        setTooltip(true);
      }, 500);
      setTimer(timeout);
    } else {
      setTooltip(false);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [showTooltip]);

  const handleSelect = (value) => {
    const roomType = URL_SLUG__ROOM_TYPE_MAP[value?.value];
    navigate(`/newdesigns/${value?.value}?roomType=${roomType}&filterBy=${roomType}`);
  };

  const handleSearchToggle = (value) => {
    setSearchToggle(!searchToggle);
  };

  const notificationToggle = (e) => {
    if (isGuestUser()) return;
    Mixpanel.track(true, MxEvent.NOTIFICATION_PANEL_VIEWED);
    // e?.stopPropagation?.();
    handleHideMenu();
    setSearchToggle(false);
    setUserCardVisiblity(false);
    setNotification(!notification);
    dispatcher(setNotificationCount(0));
    if (notificationCount) {
      apiReadNewNotifications();
    }
  };

  return (
    <>
      <Navbar expand="md" className="page-nav common-nav top-nav" collapseOnSelect id="commonMenu">
        <Navbar.Toggle
          area-controls="topNavBarToggle"
          id="hamburgerMenu"
          onClick={(e) => {
            e.stopPropagation();
            setIsMenuVisible(!isMenuVisible);
            setShowMenu(!showMenu);
            setSearchToggle(false);
            notification && setNotification(false);
            cardFlag && setUserCardVisiblity(false);
          }}
        />

        <div
          className="d-flex align-items-center justify-content-center"
          style={{ width: 'var(--sidebar-width)' }}>
          <img
            src={ImagineLogo}
            className="imagine-io-logo"
            style={{ width: '60%', cursor: 'pointer' }}
            onClick={() => navigate(ADMIN_DASHBOARD)}
          />
        </div>
        <div className="header-right-section d-flex flex-row justify-content-end align-items-center">
          {/* form */}
          <div
            className={` hiddenOnMobile search-toggle-icon ${searchToggle ? 'search-close' : ''}`}
            onClick={handleSearchToggle}>
            {searchToggle ? <CloseIcon /> : <SearchBarIcon />}
          </div>
          {!isGuestLogin && (
            <>
            {!hideSearchBar(location?.pathname) && (
              <UniversalSearchForm
                className={`hiddenOnMobile ${searchToggle ? `serach-open` : ''}`}
                isOtherMenuOpen={notification || cardFlag || isMenuVisible}
              />
            )}
              

              {/* notifications */}
              <button
                notificationcount={notificationCount}
                className={`hiddenOnMobile notification ${notificationCount ? 'count' : ''} ${
                  notification ? 'active' : ''
                } ${!notification && notificationCount ? 'hasNotification' : ''}`}
                onClick={(e) => {
                  notificationToggle(e);
                }}>
                <NotificationsIcon />
                {/* {notification ? (
              <NotificationsActiveIcon />
            ) : notificationCount ? (
              <NotificationsBellIcon />
            ) : (
            )} */}
              </button>
              {/* user card */}
              {/* <UserCard
                isGuestLogin={isGuestLogin}
                cardFlag={cardFlag}
                setUserCardVisiblity={setUserCardVisiblity}
                handleClosePopUp={() => {
                  handleHideMenu();
                  setSearchToggle(false);
                  setNotification(false);
                }}
              /> */}
            </>
          )}
          {isGuestLogin && (
            <Button
              size="xs"
              onClick={() => {
                logout();
              }}
              title="Logout"
              className="sign-out-button">
              <LogoutIcon />
              <span className="pe-2 ps-1">Logout</span>
            </Button>
          )}

          {/* {!isGuestUser() && showNewFileBtn && !isGuestLogin ? (
            <MenuDropdown
              openButton={
                <>
                  <PlusIcon /> <span>New file</span>
                </>
              }
              menu={ActionMenu}
              handleSelect={handleSelect}
              className="d-none d-md-block"
            />
          ) : null} */}

          {!isGuestLogin ? (
            <OrganizationSwitcher
              setUserCardVisiblity={setUserCardVisiblity}
              isGuestLogin={isGuestLogin}
              refreshOrgList={refreshOrgList}
            />
          ) : null}
        </div>
      </Navbar>
      <NotificationsPanel
        setRefreshOrgList={setRefreshOrgList}
        show={notification}
        notificationCount={notificationCount}
        notificationToggle={notificationToggle}
      />
    </>
  );
}
